import React from 'react';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

const AttendanceTable = ({ workSessions = [], summaryByUser = [], activeOrg }) => {
    const currency = activeOrg?.valute || 'N/A';

    return (
        <div className="bg-gray-900 text-gray-200 p-6 rounded-lg shadow-lg">
            {/* Summary by User */}
            <h2 className="text-xl font-bold mb-4">Summary by User</h2>
            <table className="min-w-full border border-gray-700 mb-6">
                <thead>
                    <tr className="bg-gray-800 text-gray-300">
                        <th className="px-4 py-2 border border-gray-700">User</th>
                        <th className="px-4 py-2 border border-gray-700">Total Hours</th>
                        <th className="px-4 py-2 border border-gray-700">Paid Amount ({currency})</th>
                        <th className="px-4 py-2 border border-gray-700">Unpaid Amount ({currency})</th>
                    </tr>
                </thead>
                <tbody>
                    {summaryByUser.length > 0 ? (
                        summaryByUser.map((user, index) => (
                            <tr key={index} className="border-t border-gray-700">
                                <td className="px-4 py-2 border border-gray-700">{user.userName}</td>
                                <td className="px-4 py-2 border border-gray-700">{user.totalHours}</td>
                                <td className="px-4 py-2 border border-gray-700">{user.paidAmount}</td>
                                <td className="px-4 py-2 border border-gray-700">{user.unpaidAmount}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td className="px-4 py-2 border border-gray-700 text-center" colSpan="4">
                                No summary data available.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            {/* Detailed Sessions */}
            <h2 className="text-xl font-bold mb-4">Detailed Sessions</h2>
            <table className="min-w-full border border-gray-700 mb-4">
                <thead>
                    <tr className="bg-gray-800 text-gray-300">
                        <th className="px-4 py-2 border border-gray-700">Date</th>
                        <th className="px-4 py-2 border border-gray-700">User</th>
                        <th className="px-4 py-2 border border-gray-700">Check-In</th>
                        <th className="px-4 py-2 border border-gray-700">Check-Out</th>
                        <th className="px-4 py-2 border border-gray-700">Location</th>
                        <th className="px-4 py-2 border border-gray-700">Hours Worked</th>
                        <th className="px-4 py-2 border border-gray-700">Paid Status</th>
                        <th className="px-4 py-2 border border-gray-700">Pay ({currency})</th>
                    </tr>
                </thead>
                <tbody>
                    {workSessions.length > 0 ? (
                        workSessions.map((session, index) => (
                            <tr key={index} className="border-t border-gray-700">
                                <td className="px-4 py-2 border border-gray-700">{session.date}</td>
                                <td className="px-4 py-2 border border-gray-700">{session.user.name || 'Unknown'}</td>
                                <td className="px-4 py-2 border border-gray-700">
                                    {new Date(session.checkIn).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })}
                                </td>
                                <td className="px-4 py-2 border border-gray-700">
                                    {new Date(session.checkOut).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })}
                                </td>
                                <td className="px-4 py-2 border border-gray-700">{session.locationCheckIn || 'Unknown'}</td>
                                <td className="px-4 py-2 border border-gray-700">{session.hoursWorked}</td>
                                <td className="px-4 py-2 border border-gray-700 text-center">
                                    {session.paid ? <FaCheckCircle className="text-green-500" /> : <FaTimesCircle className="text-red-500" />}
                                </td>
                                <td className="px-4 py-2 border border-gray-700">{session.pay} {currency}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td className="px-4 py-2 border border-gray-700 text-center" colSpan="8">
                                No session data available.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default AttendanceTable;
